import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // H-08: no localStorage — the httpOnly cookie is sent automatically by the browser.
    // A 401 here simply means no active session.
    authAPI.getProfile()
      .then((res) => setUser(res.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    // Cookie is set server-side (httpOnly). We don't touch localStorage.
    const profileRes = await authAPI.getProfile();
    const userData = profileRes.data.data;
    setUser(userData);
    return userData;
  };

  const logout = async () => {
    try { await authAPI.logout(); } catch (_) {}
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const res = await authAPI.getProfile();
      setUser(res.data.data);
    } catch (_) {}
  };

  const updateCompanyLogo = (logoUrl) => {
    setUser((prev) => {
      if (!prev) return prev;
      return { ...prev, company: prev.company ? { ...prev.company, logo: logoUrl } : prev.company };
    });
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, refreshUser, updateCompanyLogo }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
